import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const ApplicationProcess = ({
  isIconSmall,
  ...props
}: {
  isIconSmall?: boolean
}) => {
  if (isIconSmall) {
    return (
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={29}
        height={29}
        fill="none"
        {...props}
      >
        <G clipPath="url(#a)">
          <Mask
            id="b"
            width={29}
            height={29}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'luminance',
            }}
          >
            <Path
              fill="#fff"
              d="M23.662.808H4.994A4.667 4.667 0 0 0 .328 5.474v18.667a4.667 4.667 0 0 0 4.667 4.667h18.667a4.667 4.667 0 0 0 4.666-4.667V5.474A4.667 4.667 0 0 0 23.662.808Z"
            />
          </Mask>
          <G mask="url(#b)">
            <Path
              fill="#F2F7FF"
              d="M23.662.808H4.994A4.667 4.667 0 0 0 .328 5.474v18.667a4.667 4.667 0 0 0 4.667 4.667h18.667a4.667 4.667 0 0 0 4.666-4.667V5.474A4.667 4.667 0 0 0 23.662.808Z"
            />
            <Path
              fill="url(#c)"
              d="M21.73 14.545V29.74a1.73 1.73 0 0 1-1.73 1.73H8.957a1.73 1.73 0 0 1-1.73-1.73V14.545c0-.955.775-1.73 1.73-1.73h11.04c.958 0 1.733.775 1.733 1.73Z"
            />
            <Path
              fill="url(#d)"
              d="M20.698 14.938v14.408a.982.982 0 0 1-.985.982H9.243a.983.983 0 0 1-.985-.982V14.938c0-.543.441-.984.984-.984h10.471c.543 0 .985.441.985.984Z"
            />
            <Path
              fill="url(#e)"
              d="M18.097 12.315v1.923a.394.394 0 0 1-.392.393h-6.469a.394.394 0 0 1-.392-.393v-1.926c0-.216.176-.392.392-.392h1.707c0-1.057 1.073-1.858 2.188-1.387.543.229.87.795.87 1.387v.006h1.707a.386.386 0 0 1 .39.39Z"
            />
            <Path
              fill="#BF9864"
              d="M18.1 13.751v.49a.394.394 0 0 1-.392.393h-6.472a.394.394 0 0 1-.392-.393v-.49c0 .216.176.392.392.392h6.472a.394.394 0 0 0 .392-.392Z"
            />
            <Path
              fill="#fff"
              d="M14.473 12.42a.52.52 0 1 0 0-1.04.52.52 0 0 0 0 1.04Z"
            />
            <Path
              fill="#F2F7FF"
              d="M18.61 17.14h-8.167a.583.583 0 0 0-.584.584v.583c0 .323.261.584.584.584h8.166a.583.583 0 0 0 .584-.584v-.583a.583.583 0 0 0-.584-.583ZM18.61 20.64h-8.167a.583.583 0 0 0-.584.584v.583c0 .323.261.584.584.584h8.166a.583.583 0 0 0 .584-.584v-.583a.583.583 0 0 0-.584-.583ZM18.61 24.14h-8.167a.583.583 0 0 0-.584.584v.583c0 .323.261.584.584.584h8.166a.583.583 0 0 0 .584-.584v-.583a.583.583 0 0 0-.584-.583Z"
            />
          </G>
        </G>
        <Defs>
          <RadialGradient
            id="c"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-12.24651 16.89305 -14.9305 -10.82378 20.627 14.03)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="d"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-10.50405 14.82882 -13.00894 -9.21493 19.751 15.02)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="e"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-6.37672 3.96993 -3.11129 -4.99752 16.95 10.648)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
          <ClipPath id="a">
            <Path fill="#fff" d="M.328.808h28v28h-28z" />
          </ClipPath>
        </Defs>
      </Svg>
    )
  }
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_4356_239)">
        <Mask
          id="a"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={48}
          height={48}
        >
          <Path
            d="M40 0H8a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V8a8 8 0 00-8-8z"
            fill="#fff"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            d="M40 0H8a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V8a8 8 0 00-8-8z"
            fill="#F2F7FF"
          />
          <Path
            d="M36.683 23.55v26.047a2.967 2.967 0 01-2.965 2.965H14.786a2.967 2.967 0 01-2.966-2.965V23.55a2.967 2.967 0 012.966-2.966h18.926a2.968 2.968 0 012.971 2.966z"
            fill="url(#paint0_radial_4356_239)"
          />
          <Path
            d="M34.92 24.224v24.7c0 .93-.758 1.682-1.688 1.682h-17.95c-.931 0-1.688-.752-1.688-1.682v-24.7c0-.931.757-1.688 1.687-1.688h17.95c.931 0 1.688.757 1.688 1.688z"
            fill="url(#paint1_radial_4356_239)"
          />
          <Path
            d="M30.465 19.727v3.297c0 .37-.302.673-.672.673H18.704a.675.675 0 01-.673-.673v-3.302c0-.37.303-.673.673-.673h2.926c0-1.81 1.84-3.184 3.75-2.377.931.393 1.492 1.362 1.492 2.377v.011h2.927a.661.661 0 01.666.668z"
            fill="url(#paint2_radial_4356_239)"
          />
          <Path
            d="M30.471 22.188v.841c0 .37-.302.673-.672.673H18.703a.675.675 0 01-.673-.673v-.84c0 .37.303.672.673.672H29.8c.37 0 .672-.303.672-.673z"
            fill="#BF9864"
          />
          <Path
            d="M24.25 19.907a.891.891 0 100-1.783.891.891 0 000 1.783z"
            fill="#fff"
          />
          <Path
            d="M31.336 28h-14a1 1 0 00-1 1v1a1 1 0 001 1h14a1 1 0 001-1v-1a1 1 0 00-1-1zM31.336 34h-14a1 1 0 00-1 1v1a1 1 0 001 1h14a1 1 0 001-1v-1a1 1 0 00-1-1zM31.336 40h-14a1 1 0 00-1 1v1a1 1 0 001 1h14a1 1 0 001-1v-1a1 1 0 00-1-1z"
            fill="#F2F7FF"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_4356_239"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(125.94 11.614 20.208) scale(35.7687 31.6133)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_4356_239"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(125.312 10.35 20.79) scale(31.1524 27.3292)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_4356_239"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-10.93153 6.8056 -5.33364 -8.56719 28.499 16.869)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <ClipPath id="clip0_4356_239">
          <Path fill="#fff" d="M0 0H48V48H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default ApplicationProcess
